// src/utils/progressUtils.ts
import { CardCustomization } from "../types/card.types";

export const calculateCompletionPercentage = (
  customization: CardCustomization | null,
): number => {
  if (!customization) return 0;

  let score = 0;
  if (customization.recipientName?.length > 0) score += 25;
  if (customization.message?.length > 10) score += 25;
  if (customization.personalNote && customization.personalNote.length > 0)
    score += 10;
  if (customization.recipientImage) score += 25;
  if (customization.includeBouquet && (customization.bouquetAmount || 0) > 0)
    score += 15;

  return Math.min(score, 100);
};

export const isStepCompleted = (
  tabId: string,
  completionPercentage: number,
  stepIndex: number,
): boolean => {
  return completionPercentage >= (stepIndex + 1) * 25;
};
